import { Checkbox, styled } from "@mui/material";

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export default StyledCheckbox;
